import React from 'react';

const Logo = ({ className = "", color = "current" }) => {
  const fillColor = color === "current" ? "currentColor" : color === "dark" ? "#1c1917" : "#ffffff";
  const accentColor = "#b45309"; // amber-700
  
  return (
    <svg viewBox="0 0 200 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      {/* Modern Classic II Mark */}
      {/* First I - with serifs */}
      <path
        d="M4 8H12V10H9.5V30H12V32H4V30H6.5V10H4V8Z"
        fill={fillColor}
      />
      {/* Second I - with serifs */}
      <path
        d="M16 8H24V10H21.5V30H24V32H16V30H18.5V10H16V8Z"
        fill={fillColor}
      />
      {/* Amber accent dot between */}
      <circle cx="14" cy="36" r="2" fill={accentColor} />
      {/* Text */}
      <text x="32" y="27" fontFamily="'Playfair Display', Georgia, serif" fontSize="17" fontWeight="500" fill={fillColor} letterSpacing="-0.01em">
        Italian Insiders
      </text>
    </svg>
  );
};

export default Logo;
